import { render, staticRenderFns } from "./new-year-gift-pop.vue?vue&type=template&id=1952ffa8&scoped=true&"
import script from "./new-year-gift-pop.vue?vue&type=script&lang=js&"
export * from "./new-year-gift-pop.vue?vue&type=script&lang=js&"
import style0 from "./new-year-gift-pop.vue?vue&type=style&index=0&id=1952ffa8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952ffa8",
  null
  
)

export default component.exports